import React, { FC } from 'react';

import { useTranslation } from '@modernloop/i18n';

import { BetaTagBase } from 'src/components/BetaTag';

interface ApiMcpBetaTagProps {
  /** Badge color; use `inherit` when a parent sets contrast (e.g. active settings nav). */
  color?: string;
}

/** Beta badge for API key and MCP surfaces that are still in beta. */
export const ApiMcpBetaTag: FC<ApiMcpBetaTagProps> = ({ color }) => {
  const { t } = useTranslation();

  return <BetaTagBase color={color} tooltip={t('hiring-dashboard-common:common.betaTag.tooltip')} />;
};
